<div class="m-3">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-left" style="font-size: 30px; font-weight: bold">
          Bulk Update
        </div>
        <div class="modal-header-right">
          <button type="button" class="close" (click)="close()">
            <i class="icon-close"></i>
          </button>
        </div>
  
      </div>
    </div>
    <div class="ml-3 pl-1">
      <strong>
        Changes will reflect in the selected {{ datatableTableName | lowercase }}. Any field not edited below will remain unchanged.
      </strong>
    </div>
    <section class="records-main-section new-records-main-section">
      <form *ngIf="form" [formGroup]="form">
        <div class="tabs-conatent-main edit-form">
          <div class="tab-inner-main-root-bx">
            <div class="row">
              <div class="col-md-4">
                <h3 class="text-right">Field Name</h3>
              </div>
              <div class="col-md-2">
                <h3 >Update Field</h3>
              </div>
              <div class="col-md-6">
                <h3>Field Value</h3>
              </div>
            </div>
            <ng-container *ngFor="let col of columns">
              <div class="row" *ngIf="isColumnUpdateAllowed(col)" style="align-items: center; height: min-content;">
                <div class="col-md-4 text-right" style="margin-top: -15px;">
                  {{ col.Name }}
                </div>
                <div class="col-md-2 text-right">
                  <app-checkbox
                    [form]="fieldIdToControl(col.FieldName)"
                    controlName="IsDisabled"
                    type="toggle"
                  ></app-checkbox>
                </div>
                <div class="col-md-6">
                  <ng-container
                    *ngTemplateOutlet="
                      inputTypeSelector(col);
                      context: { col: col }
                    "
                  ></ng-container>
                </div>
              </div>
            </ng-container>
            <div class="row"
            *ngIf="datatableTableName === 'Subscriptions' && fieldIdToControl('delivery_schedule')?.value?.Value === 'weekly'"
            >
              <div class="col-md-4 text-right">
                Schedule Days
              </div>
              <div class="col-md-2">
              </div>
              <div
              class="ml-auto col-lg-6"
            >
              <div
                class="form-group form-group-checkbox-new01"
                *ngFor="
                  let field of subsDaysAsArray.controls;
                  let i = index
                "
                [formGroup]="asFormGroup(field)"
              >
                <app-checkbox
                  [form]="asFormGroup(field)"
                  [label]="weekDays[i]"
                  controlName="Status"
                ></app-checkbox>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary float-right btn-lg update-btn"
            [disabled]="isFormValid()"
            (click)="updateData()"
          >
            Update
          </button>
        </div>
      </form>
    </section>
  
    <ng-template let-col="col" #input>
      <app-input
        class="form-group"
        [form]="fieldIdToControl(col.FieldName)"
        controlName="Value"
        [type]="inputFieldType(col)"
        [placeholder]="inputFieldPlaceholder(col)"
        [disabled]="!fieldIdToControl(col.FieldName).value.IsDisabled"
        [IsFromForm]="true"
      ></app-input>
    </ng-template>
    <ng-template let-col="col" #checkbox>
      <div class="form-custom-div">
        <div class="form-group radio-form-group">
          <div class="custom-radio-root" style="margin-top: 10px; padding-top: 10px;">
            <app-radio [form]="fieldIdToControl(col.FieldName)" controlName="Value" [hideRequiredMark]="true"
              [disabled]="!fieldIdToControl(col.FieldName).value.IsDisabled" value="true" label="True"></app-radio>
            <app-radio [form]="fieldIdToControl(col.FieldName)" controlName="Value" [hideRequiredMark]="true"
              [disabled]="!fieldIdToControl(col.FieldName).value.IsDisabled" value="false" label="False"></app-radio>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template let-col="col" #select>
      <app-select
        class="form-group"
        [options]="getDropdownValues(col)"
        [id]="col.Key"
        [disabled]="!fieldIdToControl(col.FieldName).value.IsDisabled"
        [fieldName]="col.FieldName"
        [customPlaceholder]="
          fieldIdToControl(col.FieldName).value.Value === multiple_values ? multiple_values : DROPDOWN_VALUE_PLACEHOLDER
        "
        [form]="fieldIdToControl(col.FieldName)"
        controlName="Value"
        [modalLayer]="modalLayer"
        [IsFromForm]="true"
      >
      </app-select>
    </ng-template>
  
    <ng-template let-col="col" #textarea>
      <app-textarea
        class="form-group"
        [form]="fieldIdToControl(col.FieldName)"
        controlName="Value"
        [disabled]="!fieldIdToControl(col.FieldName).value.IsDisabled"
        [IsFromForm]="true"
      ></app-textarea>
    </ng-template>
  </div>
  

  <ng-template #updateActiveTemplate let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-left">
          <h4 class="modal-title">Activate/Deactivate User</h4>
        </div>
        <div class="modal-header-right">
          <button type="button" class="close" (click)="modal.close()">
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div class="modal-body-inner">
          <button class="btn btn-dark mr-4" type="button" (click)="updateUser(false)">{{this.buttonText}} user for this App</button>
          <button class="btn btn-dark" type="button" (click)="updateUser(true)">{{this.buttonText}} user for all Apps</button>
        </div>
      </div>
  
      <div class="modal-footer">
        <div class="modal-footer-bottom">
          <app-modal-action-btns
            (onReject)="modal.close()"
            [showSave]="false"
          ></app-modal-action-btns>
        </div>
      </div>
    </div>
  </ng-template>